import { Injectable } from '@angular/core';
import { switchMap, tap } from 'rxjs/operators';
import { from, of } from 'rxjs';

import { UserPreferenceResource } from './account-response.types';
import { ApiService } from '@mode/shared/util-halogen';
import { preferenceCache } from '../resource-cache';
import { SharedDataAccessWebappModule } from '../shared-data-access-webapp.module';
import { AccountFetchService } from './account-fetch.service';
import { ApiTypes } from '@mode/shared/contract-common';

@Injectable({
  providedIn: SharedDataAccessWebappModule,
})
export class PreferenceFetchService {
  constructor(
    private accountFetcher: AccountFetchService,
    private apiService: ApiService
  ) {}

  getUserPreferenceResource(username: string, options?: ApiTypes.ResourceOptions) {
    const cached = preferenceCache.get(username);
    if (cached == null) {
      return this.accountFetcher.getAccountResource(username).pipe(
        switchMap((account) =>
          from(this.apiService.getResource<UserPreferenceResource>(account, 'preference', options))
        ),
        tap((preference) => preferenceCache.set(username, preference))
      );
    } else {
      return of(cached);
    }
  }
}
